// extracted by mini-css-extract-plugin
export default {"zoomControls":"tca-z","zoomControlButton":"uca-z","zoomBanner":"vca-z","bannerButton":"wca-z","imageButton":"xca-z","zoom":"yca-z","zoomContent":"zca-z"};